import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { COMPANY, NAV, PRODUCTS } from '../../data/content';

export default function Footer() {
  const company = NAV.find((n) => n.label === 'Company');
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-navy text-white">
      <div className="container-x grid gap-12 py-8 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
        <div>
          <span className="font-display text-2xl font-bold tracking-tight">BANMORE</span>
          <p className="mono-label mt-1 text-white/40">Electricals Pvt. Ltd.</p>
          <p className="mt-6 max-w-xs text-sm leading-relaxed text-white/60">
            Leading global manufacturer of CRGO transformer core products since 1977. We make the
            heart of the transformer.
          </p>
        </div>

        <div>
          <h4 className="mono-label text-white/40">Products</h4>
          <ul className="mt-5 space-y-3">
            {PRODUCTS.map((p) => (
              <li key={p.slug}>
                <Link
                  to={`/products/${p.slug}`}
                  className="link-underline text-sm text-white/70 hover:text-white"
                >
                  {p.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mono-label text-white/40">Company</h4>
          <ul className="mt-5 space-y-3">
            {company.children.map((c) => (
              <li key={c.to}>
                <Link to={c.to} className="link-underline text-sm text-white/70 hover:text-white">
                  {c.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mono-label text-white/40">Get in Touch</h4>
          <ul className="mt-5 space-y-4 text-sm text-white/70">
            <li className="flex items-start gap-3" data-testid="footer-email">
              <Mail className="mt-0.5 h-4 w-4 text-brand-light" />
              <span>
                <span className="block break-all">{COMPANY.emailDisplay}</span>
                <span className="block break-all">{COMPANY.email2Display}</span>
              </span>
            </li>
            <li className="flex items-start gap-3">
              <Phone className="mt-0.5 h-4 w-4 text-brand-light" />
              <a href={`tel:${COMPANY.phone}`} className="link-underline hover:text-white">
                {COMPANY.phone}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="mt-0.5 h-4 w-4 text-brand-light" />
              <span>Banmore, Morena, Madhya Pradesh, India</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x flex flex-col items-start justify-between gap-2 py-6 text-xs text-white/40 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} Banmore Electricals Pvt. Ltd. All rights reserved.</p>
          <p className="mono-label">CRGO Transformer Core · India</p>
        </div>
      </div>
    </footer>
  );
}
